import { Template, ITemplateFavorites } from '@templates/types'
import { api } from 'api'
import { AppDispatch } from 'redux/store'
import { ActionType } from './submissions.reducer'

interface IDispatchItem {
  type: ActionType
  payload: Template[]
}

export function getTemplates() {
  // /api/v1/account/template/favorites
  return (dispatch: AppDispatch) => {
    api
      .get<Template[]>('/api/v1/account/template?with[]=folder')
      .then(res =>
        api.get<ITemplateFavorites[]>('/api/v1/account/template/favorites').then(response => {
          const favorites = response.data.map(fav => fav.id)
          res.data.forEach(temp => {
            temp.favorite = favorites.includes(temp.id)
          })

          const dispatchItem: IDispatchItem = {
            type: ActionType.TEMPLATES_LOADED,
            payload: res.data,
          }
          dispatch(dispatchItem)
        }),
      )
      .catch(() => {
        // dispatch({ type: 'NOT_AUTHENTICATED', payload: false })
      })
  }
}

interface ITemplateDTO {
  id: number
  name: string
  description: string
  folderId: number
  rollupDatasetId: number
  createdAt: string
  updatedAt: string
  deletedAt: string
  folder: object
  rowCount: number
  favorite: boolean
  settings: object
  integrations: string[]
}

/**
 * Fetch and add the template to the Redux submissions context.
 * - Use preventMultipleDispatches to prevent multiple dispatches of the same template;
 * this occurs when different components might call setTemplate; and we cannot rely on a
 * check of the store since the store is not updated until the dispatch is complete.
 * - the need for preventMultipleDispatches is a design flaw of the architecture; we
 * should be able to update the store with templates much higher up in the chain and make
 * the compontents consume it rather than fetch it.
 * @param {*} args
 * @param {string} args.id Template ID
 * @returns A dispatch Redux event; asynchronously calls a dispatch event,
 * no promise is returned.
 */
let preventMultipleDispatches: Record<string, boolean> = {}
export function setTemplate({ id }: { id: string }) {
  return async (dispatch: AppDispatch): Promise<void> => {
    const accountTemplateUrl = `/api/v1/account/template/${id}`

    if (preventMultipleDispatches[id]) return Promise.resolve()
    preventMultipleDispatches[id] = true

    try {
      const { data } = await api.get<ITemplateDTO>(accountTemplateUrl)
      const { [id]: _, ...rest } = preventMultipleDispatches

      preventMultipleDispatches = rest

      const obj = Object.entries(data).reduce((memo, [key, value]) => {
        if (key !== 'rollupDatasetId') return { ...memo, [key]: value }

        memo.rollup_dataset_id = +value

        return memo
      }, {} as Template)

      const dispatchItem: IDispatchItem = { type: ActionType.TEMPLATES_LOADED, payload: [obj] }
      dispatch(dispatchItem)
    } catch (error) {
      console.error(`Failed to fetch template with id ${id}:`, error)
    }

    return Promise.resolve()
  }
}

export function toggleFavorite(template) {
  return () => {
    if (template.favorite) {
      void api.put('/api/v1/account/template/favorites/remove', { template_id: template.id })
    } else {
      void api.put('/api/v1/account/template/favorites/add', { template_id: template.id })
    }
    // nothing because we're going to optimistically render here.
    // dispatch({ type: 'TOGGLED_FAVORITE', payload: template})
  }
}
